function truncate(s) {
    return s.length > 200 ? s.slice(0, 200) + " [...]" : s;
}
var candidates = [
    function (element) { return element.textContent; },
    function (element) {
        if (element.tagName === 'INPUT') {
            var input = element;
            var type = input.getAttribute('type');
            if (type === 'button' || type === 'submit') {
                return input.value;
            }
        }
        // tslint:disable-next-line no-null-keyword
        return null;
    },
    function (element) { return element.getAttribute('aria-label'); },
    function (element) { return element.getAttribute('alt'); },
    function (element) { return element.getAttribute('title'); },
    function (element) { return element.getAttribute('placeholder'); },
];
export function getElementContent(element) {
    for (var _i = 0, candidates_1 = candidates; _i < candidates_1.length; _i++) {
        var candidate = candidates_1[_i];
        var content = candidate(element);
        if (typeof content === 'string') {
            var trimedContent = content.trim();
            if (trimedContent) {
                return truncate(trimedContent);
            }
        }
    }
    return element.parentElement ? getElementContent(element.parentElement) : '';
}
//# sourceMappingURL=getElementContent.js.map